var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "87px",
    viewBox: "0 0 87 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder_geniric") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder_geniric",
    fill: "#EAEAEA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy",
    transform: "translate(2.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,33 L49,33 L49,4 L4,4 L4,33 Z M0,0 L53,0 L53,37 L0,37 L0,0 Z",
    id: "Rectangle-13-Copy-4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-18-Copy",
    points: "9 27 15.0010941 10 25.7773523 22.1753609 32 19.1828495 32 27"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-9-Copy",
    cx: 41,
    cy: 14,
    r: 4
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-18",
    fillRule: "nonzero",
    points: "34.4493676 6.90908193 77.1698929 31.0948432 61.2442191 58.1291196 55.3671998 54.9762134 55.7477501 60.3362417 63.3641812 64.3911772 84.0592295 29.2494862 32.5955467 0.113881444 17.5008772 26.7667737 23.663614 25.61717"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-9-Copy-4",
    cx: 62,
    cy: 37,
    r: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20-Copy",
    points: "33 25 43 25 41.1833819 17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.2f9a545030bc24ca01b98b360143101a.svg";
export { ForwardRef as ReactComponent };